module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as3209-c780023a571d0ac4adbd50a760321eb6.jpg";